import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from "react-router-dom";
import "./blogPostThumb.css";

export default class blogPostThumb extends Component {
  constructor(props) {
      super(props);
  }
  render() {
    return (
      <Fade bottom distance="0%" duration={1500}>
        <div className="blog-post-thumb tiny-padding">
          <Link to={'/article?id='+this.props.slug}>
            <div className="white-background shadow">
              <h6 className="black subheading">{this.props.date}</h6>
              <h3 className="black" style={{marginLeft:"0px"}}>{this.props.title}</h3>
              <p className="black">{this.props.description}</p>
              <div className="button primary-background white" style={{marginTop:"20px"}}>{'Continue Reading'}</div>
            </div>
          </Link>
        </div>
      </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/blogPostThumb/index.js